export const ProjectData = [
  {
    id: 1,
    title: 'Gym-App',
    about: 'Framework used',
    tags: ['ReactJS', 'Html/Css', 'Javascript'],
    url: 'https://www.gregoryjaccottet.com',
    image:
      'https://raw.githubusercontent.com/SeanJordaan/Portfolio/main/src/assets/gymapp1.png',
  },
  {
    id: 1,
    title: 'Gym-App',
    about:
      'This is a gym application done useing Reactjs, calling a API for all the workout information. Depolyed using Netlify',
    tags: ['Netlify'],
    demo: 'https://seans-gym-app.netlify.app/',
    github: 'https://github.com/SeanJordaan/Portfolio',
    image:
      'https://raw.githubusercontent.com/SeanJordaan/Portfolio/main/src/assets/gymapp2.png',
  },
  {
    id: 2,
    title: 'Coronavirus-App',
    about: 'Framework used',
    tags: ['Java', 'SQL', 'Springboot'],
    url: 'https://github.com/SeanJordaan/Portfolio',
    image:
      'https://raw.githubusercontent.com/SeanJordaan/Portfolio/main/src/assets/coronavirus.png',
  },
  {
    id: 2,
    title: 'Coronavirus-App',
    about:
      'A webpage to look at the total number of coronavirus casses and the a total that has been added from the day before the API gets updates daily',
    tags: ['Heroku'],
    demo: 'https://aqueous-meadow-74094.herokuapp.com/',
    github:
      'https://github.com/SeanJordaan/coronavirus-tracker/tree/main/coronavirus-tracker',
    image:
      'https://raw.githubusercontent.com/SeanJordaan/Portfolio/main/src/assets/coronavirus2.png',
  },
  {
    id: 3,
    title: 'Random Advice',
    about: 'Framework used',
    tags: ['ReactJS', 'Html/Css'],
    url: 'https://github.com/SeanJordaan/Portfolio',
    image:
      'https://raw.githubusercontent.com/SeanJordaan/Portfolio/main/src/assets/advice1.png',
  },
  {
    id: 3,
    title: 'Random Advice',
    about:
      'This webpage can be used on mobel and desktop. It gives you some random advice generated everytime the button is clicked',
    tags: ['Netlify'],
    demo: 'https://seans-advice.netlify.app/',
    github: 'https://github.com/SeanJordaan/randomAdvice-',
    image:
      'https://raw.githubusercontent.com/SeanJordaan/Portfolio/main/src/assets/advice2.png',
  },
];
